// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recordsPage {
  width: 100%;
  min-height: calc(100vh - 76px);
  padding-bottom: 32px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.recordsPage__pageHeader {
  display: flex;
  width: calc(100% + 56px);
  min-height: 96px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin: -20px 0 22px -28px;
  padding: 16px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}
.recordsPage__heading {
  min-width: 0;
}
.recordsPage__heading p {
  max-width: 760px;
  margin: 6px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.45;
}
.recordsPage__mainCard {
  width: 100%;
  padding: 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.06);
}
.recordsPage__modal .modal-header {
  padding: 20px 24px 14px;
  border-bottom: 1px solid #e2e8f0;
}
.recordsPage__modal .modal-body {
  padding: 22px 24px 24px;
}
.recordForm__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}
.recordForm__field {
  min-width: 0;
  margin: 0;
}
.recordForm__field--wide {
  grid-column: 1 / -1;
}
.recordForm__field > label {
  display: block;
  margin-bottom: 7px;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
}
.recordForm__field .form-control,
.recordForm__field input,
.recordForm__field select {
  min-height: 42px;
  border-color: #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
}
.recordForm__field .form-control:focus,
.recordForm__field input:focus,
.recordForm__field select:focus {
  border-color: #287eb1;
  box-shadow: 0 0 0 3px rgba(40, 126, 177, 0.12);
}
.recordForm__error {
  margin-top: 6px;
  color: #c4313f;
  font-size: 12px;
  font-weight: 600;
}
.recordForm__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.recordForm__chip {
  min-height: 27px;
  padding: 3px 9px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}
.recordForm__chip:hover {
  border-color: var(--border-brand, #6fb1df);
  background: var(--surface-hover, #f8fafc);
}
.recordForm__chip--selected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
  box-shadow: none;
}
.recordForm__date > div,
.recordForm__date input {
  width: 100%;
}
.recordForm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid #e2e8f0;
}
.recordsPage__primaryBtn,
.recordsPage__secondaryBtn {
  min-height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}
.recordsPage__primaryBtn {
  border: 1px solid #1f6f9f;
  background: #1f6f9f;
  color: #fff;
}
.recordsPage__secondaryBtn {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}
.recordsPage__drawerScrim {
  position: fixed;
  z-index: 1049;
  inset: 0;
  background: rgba(15, 23, 42, 0.38);
}
.recordsPage__drawer {
  position: fixed;
  z-index: 1050;
  top: 0;
  right: 0;
  width: min(560px, calc(100vw - 32px));
  height: 100vh;
  overflow-y: auto;
  background: #f8fafc;
  box-shadow: -16px 0 40px rgba(15, 23, 42, 0.18);
}
.recordsPage__drawerHead {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: start;
  gap: 14px;
  padding: 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}
.recordsPage__drawerIcon {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #e7f3fa;
  color: #1f6f9f;
  font-size: 18px;
}
.recordsPage__eyebrow {
  margin-bottom: 3px;
  color: #1f6f9f;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.recordsPage__drawerHead h2 {
  margin: 0;
  color: #0f172a;
  font-size: 22px;
  font-weight: 800;
}
.recordsPage__drawerHead p {
  margin: 5px 0 0;
  color: #64748b;
  font-size: 13px;
}
.recordsPage__drawerHead > button {
  width: 36px;
  height: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 22px;
}
.recordsPage__drawerBody {
  padding: 20px 24px 28px;
}
.recordsPage__detailStats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}
.recordsPage__detailStats > div {
  min-width: 0;
  padding: 13px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #fff;
}
.recordsPage__detailStats span {
  display: block;
  margin-bottom: 5px;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.recordsPage__detailStats strong {
  display: block;
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  text-overflow: ellipsis;
}
.recordsPage__formPanel {
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
}
.recordsPage__formPanelHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -4px 0 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
  color: #0f172a;
  font-size: 15px;
}
.recordsPage__formPanelHead button {
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: var(--red-500, #da4453);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}
.recordsPage__formPanelHead button:hover {
  background: var(--red-600, #c4313f);
  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);
}
.recordsPage__toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 0;
}
.recordsPage__title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.recordsPage__title h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 24px;
  font-weight: 800;
}
.recordsPage__title > span,
.recordsPage__filter i {
  min-width: 27px;
  height: 22px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--slate-150, #eef2f7);
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 800;
  font-style: normal;
}
.recordsPage__search {
  position: relative;
  width: 260px;
  margin-left: 4px;
  margin-bottom: 0;
}
.recordsPage__search > span {
  position: absolute;
  left: 12px;
  top: 9px;
  color: #64748b;
}
.recordsPage__search input,
.recordsPage__filterBody input,
.recordsPage__filterBody select {
  width: 100%;
  height: 40px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  font-size: 14px;
}
.recordsPage__search input {
  padding: 0 38px 0 12px;
}
.recordsPage__search > button {
  position: absolute;
  top: 50%;
  right: 7px;
  width: 28px;
  height: 28px;
  padding: 0;
  transform: translateY(-50%);
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.recordsPage__search > button:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
.recordsPage__search input:focus,
.recordsPage__filterBody input:focus,
.recordsPage__filterBody select:focus {
  outline: 0;
  border-color: #287eb1;
  box-shadow: 0 0 0 3px rgba(40, 126, 177, 0.12);
}
.recordsPage__filter,
.recordsPage__create,
.recordsPage__edit,
.recordsPage__delete,
.recordsPage__clear {
  height: 40px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.recordsPage__filter {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}
.recordsPage__toolbar > .columnToggle {
  align-self: center;
}
.recordsPage__toolbar .columnToggle__btn {
  height: 40px;
  padding: 0 14px;
  gap: 8px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
}
.recordsPage__toolbar .columnToggle__btn:hover,
.recordsPage__toolbar .columnToggle__btn[aria-expanded='true'] {
  border-color: #287eb1;
  background: #f0f8fc;
  color: #1a6da3;
}
.recordsPage__toolbar .columnToggle__dropdown {
  min-width: 210px;
}
.recordsPage__activeFilters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: -2px 0 12px;
}
.recordsPage__activeFilters > span {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 5px;
  padding: 4px 7px 4px 10px;
  border: 1px solid var(--border-brand, #9dcced);
  border-radius: 999px;
  background: var(--blue-50, #eef8fc);
  color: var(--blue-800, #124f76);
  font-size: 12px;
}
.recordsPage__activeFilters > span button {
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}
.recordsPage__activeFilters > span button:hover {
  background: rgba(34, 126, 189, 0.12);
}
.recordsPage__activeFiltersClear {
  padding: 3px 5px;
  border: 0;
  background: transparent;
  color: var(--action-primary, #227ebd);
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}
.recordsPage__filter.isActive {
  border-color: #287eb1;
  color: #1a6da3;
}
.recordsPage__create {
  flex: 0 0 auto;
  border: 1px solid #1f6f9f;
  background: #1f6f9f;
  color: #fff;
}
.recordsPage__selection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border: 1px solid #cfe5f2;
  border-radius: 8px;
  background: #eef7fc;
  font-size: 13px;
}
.recordsPage__selection > div {
  display: flex;
  gap: 8px;
}
.recordsPage__edit,
.recordsPage__clear {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}
.recordsPage__delete {
  border: 1px solid #da4453;
  background: #da4453;
  color: #fff;
}
.recordsPage__card {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}
.recordsPage__scroll {
  overflow-x: auto;
}
.recordsPage__table {
  width: 100%;
  min-width: 980px;
  border-collapse: separate;
  border-spacing: 0;
}
.recordsPage__table th {
  padding: 11px 14px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  text-align: left;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.recordsPage__table th button {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}
.recordsPage__table th button span {
  margin-left: 4px;
}
.recordsPage__table td {
  padding: 12px 14px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
  vertical-align: middle;
}
.recordsPage__table tr:last-child td {
  border-bottom: 0;
}
.recordsPage__table tbody tr {
  cursor: pointer;
}
.recordsPage__table tbody tr:hover,
.recordsPage__table tbody tr.isSelected {
  background: #f8fafc;
}
.recordsPage__check {
  width: 44px;
  text-align: center !important;
}
.recordsPage__check input {
  width: 16px;
  height: 16px;
  accent-color: #1f6f9f;
}
.recordsPage__gender {
  padding: 4px 9px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}
.recordsPage__value {
  font-family: var(--font-data, monospace);
  color: #0f172a;
  font-weight: 700;
}
.recordsPage__empty {
  padding: 36px !important;
  text-align: center;
  color: #64748b !important;
}
.recordsPage__pagination {
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 0;
  color: #64748b;
  font-size: 13px;
}
.recordsPage__scrim {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.38);
  z-index: 1039;
}
.recordsPage__filters {
  position: fixed;
  z-index: 1040;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(360px, calc(100vw - 20px));
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: -16px 0 40px rgba(15, 23, 42, 0.16);
}
.recordsPage__filters header {
  display: flex;
  justify-content: space-between;
  min-height: 34px;
  align-items: center;
  margin: 18px 18px 0;
  padding: 0 0 12px;
  border-bottom: 1px solid #e2e8f0;
}
.recordsPage__filters h2 {
  margin: 0;
  color: #0f172a;
  font-size: 16px;
  font-weight: 800;
}
.recordsPage__filters p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 13px;
}
.recordsPage__filters header button {
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 22px;
}
.recordsPage__filterBody {
  display: grid;
  gap: 18px;
  padding: 18px 18px 24px;
  overflow: auto;
}
.recordsPage__filterBody label {
  display: grid;
  gap: 6px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}
.recordsPage__filterField {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
.recordsPage__filterField legend,
.recordsPage__dateFilter label {
  margin: 0 0 7px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}
.recordsPage__filterChips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.recordsPage__filterChips button {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  padding: 5px 10px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.recordsPage__filterChips button:hover {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eff6ff);
}
.recordsPage__filterChips button.is-selected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.recordsPage__dateFilter .sit-dp,
.recordsPage__dateFilter .sit-dp__trigger {
  width: 100%;
}
.recordsPage__dateFilter .recordsPage__datePicker .sit-dp__pop {
  position: fixed;
  z-index: 1200;
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  width: max-content;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
  overflow: auto;
  animation: none;
}
.recordsPage__dateFilter .recordsPage__datePicker .sit-cal__panes {
  flex-direction: row;
}
.recordsPage__filterBody input,
.recordsPage__filterBody select {
  padding: 0 11px;
}
.recordsPage__filters footer {
  display: flex;
  min-height: 67px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
  padding: 14px 18px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
}
.recordsPage__filters footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.recordsPage__filters footer button {
  height: 38px;
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
}
.recordsPage__clearFilters,
.recordsPage__applyFilters {
  height: 40px;
  padding: 0 15px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
}
.recordsPage__clearFilters {
  padding: 0 !important;
  border-color: transparent !important;
  background: transparent !important;
  color: var(--blue-700, #155d8c) !important;
}
.recordsPage__applyFilters {
  border: 1px solid #1f6f9f;
  background: #1f6f9f;
  color: #fff;
}
@media (max-width: 760px) {
  .recordsPage__pageHeader {
    width: calc(100% + 32px);
    min-height: 0;
    align-items: flex-start;
    flex-direction: column;
    margin-left: -16px;
    padding: 16px;
  }
  .recordForm__grid,
  .recordsPage__detailStats {
    grid-template-columns: 1fr;
  }
  .recordForm__field--wide {
    grid-column: auto;
  }
  .recordsPage__drawerBody {
    padding: 16px;
  }
  .recordsPage__search {
    width: 100%;
    margin-left: 0;
  }
  .recordsPage__create {
    margin-left: 0;
  }
  .recordsPage__selection {
    align-items: flex-start;
    flex-direction: column;
  }
  .recordsPage__selection > div {
    flex-wrap: wrap;
  }
  .recordsPage__pagination {
    flex-wrap: wrap;
  }
  .recordsPage__scrim {
    inset: 0;
  }
}
@media (max-width: 620px) {
  .recordsPage__dateFilter .recordsPage__datePicker .sit-cal__panes {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminSUView/Records/Records.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8BAA8B;EAC9B,oBAAoB;EACpB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;AACA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,YAAY;EACZ,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;;EAGE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,cAAc;AAChB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;;;EAGE,UAAU;EACV,qBAAqB;EACrB,8CAA8C;AAChD;AACA;;;;;EAKE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,8CAA8C;EAC9C,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;AACA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;AAC5C;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".recordsPage {\n  width: 100%;\n  min-height: calc(100vh - 76px);\n  padding-bottom: 32px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.recordsPage__pageHeader {\n  display: flex;\n  width: calc(100% + 56px);\n  min-height: 96px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  margin: -20px 0 22px -28px;\n  padding: 16px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n.recordsPage__heading {\n  min-width: 0;\n}\n.recordsPage__heading p {\n  max-width: 760px;\n  margin: 6px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.45;\n}\n.recordsPage__mainCard {\n  width: 100%;\n  padding: 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.06);\n}\n.recordsPage__modal .modal-header {\n  padding: 20px 24px 14px;\n  border-bottom: 1px solid #e2e8f0;\n}\n.recordsPage__modal .modal-body {\n  padding: 22px 24px 24px;\n}\n.recordForm__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n}\n.recordForm__field {\n  min-width: 0;\n  margin: 0;\n}\n.recordForm__field--wide {\n  grid-column: 1 / -1;\n}\n.recordForm__field > label {\n  display: block;\n  margin-bottom: 7px;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 800;\n}\n.recordForm__field .form-control,\n.recordForm__field input,\n.recordForm__field select {\n  min-height: 42px;\n  border-color: #cbd5e1;\n  border-radius: 8px;\n  font-size: 14px;\n}\n.recordForm__field .form-control:focus,\n.recordForm__field input:focus,\n.recordForm__field select:focus {\n  border-color: #287eb1;\n  box-shadow: 0 0 0 3px rgba(40, 126, 177, 0.12);\n}\n.recordForm__error {\n  margin-top: 6px;\n  color: #c4313f;\n  font-size: 12px;\n  font-weight: 600;\n}\n.recordForm__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n.recordForm__chip {\n  min-height: 27px;\n  padding: 3px 9px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.recordForm__chip:hover {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--surface-hover, #f8fafc);\n}\n.recordForm__chip--selected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  box-shadow: none;\n}\n.recordForm__date > div,\n.recordForm__date input {\n  width: 100%;\n}\n.recordForm__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 24px;\n  padding-top: 18px;\n  border-top: 1px solid #e2e8f0;\n}\n.recordsPage__primaryBtn,\n.recordsPage__secondaryBtn {\n  min-height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 800;\n  cursor: pointer;\n}\n.recordsPage__primaryBtn {\n  border: 1px solid #1f6f9f;\n  background: #1f6f9f;\n  color: #fff;\n}\n.recordsPage__secondaryBtn {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n.recordsPage__drawerScrim {\n  position: fixed;\n  z-index: 1049;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.38);\n}\n.recordsPage__drawer {\n  position: fixed;\n  z-index: 1050;\n  top: 0;\n  right: 0;\n  width: min(560px, calc(100vw - 32px));\n  height: 100vh;\n  overflow-y: auto;\n  background: #f8fafc;\n  box-shadow: -16px 0 40px rgba(15, 23, 42, 0.18);\n}\n.recordsPage__drawerHead {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: start;\n  gap: 14px;\n  padding: 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #fff;\n}\n.recordsPage__drawerIcon {\n  width: 44px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: #e7f3fa;\n  color: #1f6f9f;\n  font-size: 18px;\n}\n.recordsPage__eyebrow {\n  margin-bottom: 3px;\n  color: #1f6f9f;\n  font-size: 11px;\n  font-weight: 900;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n.recordsPage__drawerHead h2 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 22px;\n  font-weight: 800;\n}\n.recordsPage__drawerHead p {\n  margin: 5px 0 0;\n  color: #64748b;\n  font-size: 13px;\n}\n.recordsPage__drawerHead > button {\n  width: 36px;\n  height: 36px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  font-size: 22px;\n}\n.recordsPage__drawerBody {\n  padding: 20px 24px 28px;\n}\n.recordsPage__detailStats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 16px;\n}\n.recordsPage__detailStats > div {\n  min-width: 0;\n  padding: 13px;\n  border: 1px solid #e2e8f0;\n  border-radius: 9px;\n  background: #fff;\n}\n.recordsPage__detailStats span {\n  display: block;\n  margin-bottom: 5px;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n.recordsPage__detailStats strong {\n  display: block;\n  overflow: hidden;\n  color: #0f172a;\n  font-size: 13px;\n  text-overflow: ellipsis;\n}\n.recordsPage__formPanel {\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fff;\n}\n.recordsPage__formPanelHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: -4px 0 18px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #e2e8f0;\n  color: #0f172a;\n  font-size: 15px;\n}\n.recordsPage__formPanelHead button {\n  min-height: 40px;\n  padding: 0 14px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: var(--red-500, #da4453);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 800;\n  cursor: pointer;\n}\n.recordsPage__formPanelHead button:hover {\n  background: var(--red-600, #c4313f);\n  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);\n}\n.recordsPage__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n  padding: 0;\n}\n.recordsPage__title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.recordsPage__title h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 24px;\n  font-weight: 800;\n}\n.recordsPage__title > span,\n.recordsPage__filter i {\n  min-width: 27px;\n  height: 22px;\n  padding: 0 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: var(--slate-150, #eef2f7);\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 800;\n  font-style: normal;\n}\n.recordsPage__search {\n  position: relative;\n  width: 260px;\n  margin-left: 4px;\n  margin-bottom: 0;\n}\n.recordsPage__search > span {\n  position: absolute;\n  left: 12px;\n  top: 9px;\n  color: #64748b;\n}\n.recordsPage__search input,\n.recordsPage__filterBody input,\n.recordsPage__filterBody select {\n  width: 100%;\n  height: 40px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 14px;\n}\n.recordsPage__search input {\n  padding: 0 38px 0 12px;\n}\n.recordsPage__search > button {\n  position: absolute;\n  top: 50%;\n  right: 7px;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  transform: translateY(-50%);\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n.recordsPage__search > button:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n.recordsPage__search input:focus,\n.recordsPage__filterBody input:focus,\n.recordsPage__filterBody select:focus {\n  outline: 0;\n  border-color: #287eb1;\n  box-shadow: 0 0 0 3px rgba(40, 126, 177, 0.12);\n}\n.recordsPage__filter,\n.recordsPage__create,\n.recordsPage__edit,\n.recordsPage__delete,\n.recordsPage__clear {\n  height: 40px;\n  padding: 0 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.recordsPage__filter {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n.recordsPage__toolbar > .columnToggle {\n  align-self: center;\n}\n.recordsPage__toolbar .columnToggle__btn {\n  height: 40px;\n  padding: 0 14px;\n  gap: 8px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 700;\n}\n.recordsPage__toolbar .columnToggle__btn:hover,\n.recordsPage__toolbar .columnToggle__btn[aria-expanded='true'] {\n  border-color: #287eb1;\n  background: #f0f8fc;\n  color: #1a6da3;\n}\n.recordsPage__toolbar .columnToggle__dropdown {\n  min-width: 210px;\n}\n.recordsPage__activeFilters {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: -2px 0 12px;\n}\n.recordsPage__activeFilters > span {\n  display: inline-flex;\n  min-height: 30px;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 7px 4px 10px;\n  border: 1px solid var(--border-brand, #9dcced);\n  border-radius: 999px;\n  background: var(--blue-50, #eef8fc);\n  color: var(--blue-800, #124f76);\n  font-size: 12px;\n}\n.recordsPage__activeFilters > span button {\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: inherit;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n}\n.recordsPage__activeFilters > span button:hover {\n  background: rgba(34, 126, 189, 0.12);\n}\n.recordsPage__activeFiltersClear {\n  padding: 3px 5px;\n  border: 0;\n  background: transparent;\n  color: var(--action-primary, #227ebd);\n  font-size: 12px;\n  font-weight: 800;\n  cursor: pointer;\n}\n.recordsPage__filter.isActive {\n  border-color: #287eb1;\n  color: #1a6da3;\n}\n.recordsPage__create {\n  flex: 0 0 auto;\n  border: 1px solid #1f6f9f;\n  background: #1f6f9f;\n  color: #fff;\n}\n.recordsPage__selection {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 12px;\n  padding: 10px 12px;\n  border: 1px solid #cfe5f2;\n  border-radius: 8px;\n  background: #eef7fc;\n  font-size: 13px;\n}\n.recordsPage__selection > div {\n  display: flex;\n  gap: 8px;\n}\n.recordsPage__edit,\n.recordsPage__clear {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n.recordsPage__delete {\n  border: 1px solid #da4453;\n  background: #da4453;\n  color: #fff;\n}\n.recordsPage__card {\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n}\n.recordsPage__scroll {\n  overflow-x: auto;\n}\n.recordsPage__table {\n  width: 100%;\n  min-width: 980px;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.recordsPage__table th {\n  padding: 11px 14px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #64748b;\n  text-align: left;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n.recordsPage__table th button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  cursor: pointer;\n}\n.recordsPage__table th button span {\n  margin-left: 4px;\n}\n.recordsPage__table td {\n  padding: 12px 14px;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n  vertical-align: middle;\n}\n.recordsPage__table tr:last-child td {\n  border-bottom: 0;\n}\n.recordsPage__table tbody tr {\n  cursor: pointer;\n}\n.recordsPage__table tbody tr:hover,\n.recordsPage__table tbody tr.isSelected {\n  background: #f8fafc;\n}\n.recordsPage__check {\n  width: 44px;\n  text-align: center !important;\n}\n.recordsPage__check input {\n  width: 16px;\n  height: 16px;\n  accent-color: #1f6f9f;\n}\n.recordsPage__gender {\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: #eef2f7;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n}\n.recordsPage__value {\n  font-family: var(--font-data, monospace);\n  color: #0f172a;\n  font-weight: 700;\n}\n.recordsPage__empty {\n  padding: 36px !important;\n  text-align: center;\n  color: #64748b !important;\n}\n.recordsPage__pagination {\n  min-height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 10px 0;\n  color: #64748b;\n  font-size: 13px;\n}\n.recordsPage__scrim {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.38);\n  z-index: 1039;\n}\n.recordsPage__filters {\n  position: fixed;\n  z-index: 1040;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: min(360px, calc(100vw - 20px));\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  box-shadow: -16px 0 40px rgba(15, 23, 42, 0.16);\n}\n.recordsPage__filters header {\n  display: flex;\n  justify-content: space-between;\n  min-height: 34px;\n  align-items: center;\n  margin: 18px 18px 0;\n  padding: 0 0 12px;\n  border-bottom: 1px solid #e2e8f0;\n}\n.recordsPage__filters h2 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 16px;\n  font-weight: 800;\n}\n.recordsPage__filters p {\n  margin: 4px 0 0;\n  color: #64748b;\n  font-size: 13px;\n}\n.recordsPage__filters header button {\n  width: 30px;\n  height: 30px;\n  border: 0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  font-size: 22px;\n}\n.recordsPage__filterBody {\n  display: grid;\n  gap: 18px;\n  padding: 18px 18px 24px;\n  overflow: auto;\n}\n.recordsPage__filterBody label {\n  display: grid;\n  gap: 6px;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n}\n.recordsPage__filterField {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n.recordsPage__filterField legend,\n.recordsPage__dateFilter label {\n  margin: 0 0 7px;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n}\n.recordsPage__filterChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n.recordsPage__filterChips button {\n  display: inline-flex;\n  min-height: 32px;\n  align-items: center;\n  padding: 5px 10px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.recordsPage__filterChips button:hover {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eff6ff);\n}\n.recordsPage__filterChips button.is-selected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.recordsPage__dateFilter .sit-dp,\n.recordsPage__dateFilter .sit-dp__trigger {\n  width: 100%;\n}\n.recordsPage__dateFilter .recordsPage__datePicker .sit-dp__pop {\n  position: fixed;\n  z-index: 1200;\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  width: max-content;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  transform: translate(-50%, -50%);\n  overflow: auto;\n  animation: none;\n}\n.recordsPage__dateFilter .recordsPage__datePicker .sit-cal__panes {\n  flex-direction: row;\n}\n.recordsPage__filterBody input,\n.recordsPage__filterBody select {\n  padding: 0 11px;\n}\n.recordsPage__filters footer {\n  display: flex;\n  min-height: 67px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: auto;\n  padding: 14px 18px;\n  border-top: 1px solid #e2e8f0;\n  background: #fff;\n}\n.recordsPage__filters footer > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.recordsPage__filters footer button {\n  height: 38px;\n  min-height: 38px;\n  padding: 0 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 700;\n}\n.recordsPage__clearFilters,\n.recordsPage__applyFilters {\n  height: 40px;\n  padding: 0 15px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.recordsPage__clearFilters {\n  padding: 0 !important;\n  border-color: transparent !important;\n  background: transparent !important;\n  color: var(--blue-700, #155d8c) !important;\n}\n.recordsPage__applyFilters {\n  border: 1px solid #1f6f9f;\n  background: #1f6f9f;\n  color: #fff;\n}\n@media (max-width: 760px) {\n  .recordsPage__pageHeader {\n    width: calc(100% + 32px);\n    min-height: 0;\n    align-items: flex-start;\n    flex-direction: column;\n    margin-left: -16px;\n    padding: 16px;\n  }\n  .recordForm__grid,\n  .recordsPage__detailStats {\n    grid-template-columns: 1fr;\n  }\n  .recordForm__field--wide {\n    grid-column: auto;\n  }\n  .recordsPage__drawerBody {\n    padding: 16px;\n  }\n  .recordsPage__search {\n    width: 100%;\n    margin-left: 0;\n  }\n  .recordsPage__create {\n    margin-left: 0;\n  }\n  .recordsPage__selection {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .recordsPage__selection > div {\n    flex-wrap: wrap;\n  }\n  .recordsPage__pagination {\n    flex-wrap: wrap;\n  }\n  .recordsPage__scrim {\n    inset: 0;\n  }\n}\n@media (max-width: 620px) {\n  .recordsPage__dateFilter .recordsPage__datePicker .sit-cal__panes {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
